<div class="fb-filter-paginator">
	<div class="fb-pagination-container">
		<button class="fb-page-button" (click)="firstPage()"
				[ngClass]="currentPage === 1? 'fb-disabled': ''"
				[disabled]="currentPage === 1">
			<span class="material-symbols-outlined ">
				keyboard_double_arrow_left
			</span>
		</button>
		<button class="fb-page-button" (click)="prevPage()"
				[ngClass]="currentPage === 1? 'fb-disabled': ''"
				[disabled]="currentPage === 1">
			<span class="material-symbols-outlined ml-1">
				arrow_back_ios
			</span>
		</button>

		<ng-container *ngFor="let page of pages">
			<button class="fb-page-button" (click)="changePage(page)" [class.active]="currentPage === page" >
				{{ page }}
			</button>
		</ng-container>

		<button class="fb-page-button" (click)="nextPage()"
				[ngClass]="currentPage === totalPages? 'fb-disabled': ''"
				[disabled]="currentPage === totalPages">
			<span class="material-symbols-outlined">
				arrow_forward_ios
			</span>
		</button>
		<button class="fb-page-button" (click)="lastPage()"
				[ngClass]="currentPage === totalPages? 'fb-disabled': ''"
				[disabled]="currentPage === totalPages">
			<span class="material-symbols-outlined">
				double_arrow
			</span>
		</button>
	</div>
</div>
